module.exports = __webpack_public_path__ + "img/icon-notification.b1dc3ed1.svg";